export default function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-scale/src/colors.js
// module id = 319
// module chunks = 0